import React, { lazy } from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";

// Pre-rendered (react-snap) public pages stay as eager imports: they're served as
// static HTML on first paint, and createRoot() erases that static markup as soon as
// React commits. If these were lazy, the erase happens immediately but the replacement
// chunk arrives after a network round-trip, leaving a blank gap exactly where the LCP
// element used to paint instantly. None of these carry the heavy deps (antd/primereact)
// that caused the original bundle bloat, so eager-loading them costs little.
import Home from "../home/home";
import Faq from "../faq/faq";
import Contact from "../contact/contact";
import TaxiServiceInMikkah from "../taxiServiceMakkah/taxi-service-makkah";
import About from "../about/about";
import TaxiServiceInMadinah from "../taxiServiceMadinah/taxi-service-madinah";
import JaddahAirportTaxiService from "../jaddahAirportTaxiService/jaddah-airport-taxi-service";
import HotelTransport from "../hotelTransport/hotel-transport";
import AirportTransfers from "../airportTransfers/airportTransfers";
import ZiyaratTaxiService from "../ziyaratTaxiService/ziyarat-taxi-service";
import Privacypolicy from "../pages/privacypolicy/privacypolicy";
import TermsCondition from "../pages/termscondition/termscondition";
import BlogList from "../blog/bloglist";
import BlogDetails from "../blog/blogdetails";
import ListingGrid from "../package/listinggrid";
import ListingDetails from "../package/listingDetails";
import ArHome from "../home/ar-home";
import ArAbout from "../about/ar-about";
import ArContact from "../contact/ar-contact";
import ArFaq from "../faq/ar-faq";
import ArTaxiServiceInMikkah from "../taxiServiceMakkah/ar-taxi-service-makkah";
import ArTaxiServiceInMadinah from "../taxiServiceMadinah/ar-taxi-service-madinah";
import ArJaddahAirportTaxiService from "../jaddahAirportTaxiService/ar-jaddah-airport-taxi-service";
import ArHotelTransport from "../hotelTransport/ar-hotel-transport";
import ArAirportTransfers from "../airportTransfers/ar-airportTransfers";
import ArZiyaratTaxiService from "../ziyaratTaxiService/ar-ziyarat-taxi-service";

// Everything below is never pre-rendered (logged-in app / auth-only routes) and is
// where the real bundle bloat lived (antd, primereact, booking flow) — safe to lazy-load.
const Login = lazy(() => import("../login/login"));
const ForgotPassword = lazy(() => import("../authentication/forgotpassword"));
const ResetPassword = lazy(() => import("../authentication/resetpassword"));
const Pricing = lazy(() => import("../pages/pricing/pricing"));
const BookingCheckout = lazy(() => import("../booking/bookingCheckout"));
const Booking = lazy(() => import("../booking/booking"));
const Invoice = lazy(() => import("../booking/invoice"));
const OurTeam = lazy(() => import("../pages/ourteam/ourTeam"));
const Testimonials = lazy(() => import("../pages/testimonial/testimonials"));
const Maintenance = lazy(() => import("../pages/maintenance/maintenance"));
const Comingsoon = lazy(() => import("../pages/comingsoon/comingsoon"));
const Error404 = lazy(() => import("../pages/errorpages/error404"));
const Error500 = lazy(() => import("../pages/errorpages/error500"));
const UserSettings = lazy(() => import("../user/settings/usersettings"));
const UserDashboard = lazy(() => import("../user/userdashboard"));
const UserIntegration = lazy(() => import("../user/userintegration"));
const UserSecurity = lazy(() => import("../user/settings/usersecurity"));
const UserPreferences = lazy(() => import("../user/settings/userpreferences"));
const UserNotification = lazy(() => import("../user/settings/usernotification"));
const UserWishList = lazy(() => import("../user/wishlist/userwishlist"));
const UserMessages = lazy(() => import("../user/usermessages"));
const UserDocuments = lazy(() => import("../user/userdocuments"));
const UserTransportDocuments = lazy(() => import("../user/transportdocuments"));
const UserReview = lazy(() => import("../user/userreview"));
const UserBookingCancelled = lazy(() => import("../user/userbookingcancelled"));
const UserBookings = lazy(() => import("../user/userbookings"));
const UserBookingUpcoming = lazy(() => import("../user/user-booking-upcoming"));
const UserBookingComplete = lazy(() => import("../user/user-booking-complete"));
const UserBookingInprogress = lazy(() =>
  import("../user/user-booking-inprogress").then((m) => ({ default: m.UserBookingInprogress }))
);
const UserPayment = lazy(() => import("../user/userpayment"));
const SignUp = lazy(() => import("../register/signup"));

const routes = all_routes;



export const publicRoutes = [
  {
    path: routes.home,
    name: "home",
    element: <Home />,
    route: Route,
  },
  
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index"/>,
    route: Route,
  },
  {
    path: "*",
    name: "NotFound",
    element: <Navigate to="/index" />,
    route: Route,
  },
 
  {
    path: routes.contact,
    name: "contact",
    element: <Contact/>,
    route: Route,
  },
  {
    path: routes.bloglist,
    name: "blog",
    element: <BlogList />,
    route: Route,
  },
  {
    path: `${routes.bloglist}/:slug`,
    name: "blog-details",
    element: <BlogDetails />,
    route: Route,
  },
  {
    path: routes.about,
    name: "about",
    element: <About />,
    route: Route,
  },

  {
    path: routes.faq,
    name: "faq",
    element: <Faq />,
    route: Route,
  },
  {
    path: routes.privacypolicy,
    name: "privacy-policy",
    element: <Privacypolicy />,
    route: Route,
  },
  {
    path: routes.signup,
    name: "register",
    element: <SignUp />,
    route: Route,
  },
  {
    path: routes.login,
    name: "login",
    element: <Login />,
    route: Route,
  }
  ,
  {
    path: routes.taxiServiceMakkah,
    name: "taxi-service-makkah",
    element: <TaxiServiceInMikkah />,
    route: Route,
  },
  {
    path: routes.taxiServiceMadinah,
    name: "taxi-service-madinah",
    element: <TaxiServiceInMadinah />,
    route: Route,
  },
  {
    path: routes.jaddahAirportTaxiService,
    name: "jaddah-airport-taxi-service",
    element: <JaddahAirportTaxiService />,
    route: Route,
  },
  {
    path: routes.hotelTransport,
    name: "hotel-transport",
    element: <HotelTransport />,
    route: Route,
  },
  {
    path: routes.airportTransfers,
    name: "airport-transfers",
    element: <AirportTransfers />,
    route: Route,
  },
  {
    path: routes.ziyaratTaxiService,
    name: "ziyarat-taxi-service",
    element: <ZiyaratTaxiService />,
    route: Route,
  },
  {
    path: routes.legacyZiyaratTaxiService,
    name: "legacy-ziyarat-tax-service",
    element: <Navigate to={routes.ziyaratTaxiService} replace />,
    route: Route,
  },



];

export const arabicRoutes = [
  {
    path: "/ar",
    name: "ar-home",
    element: <ArHome />,
    route: Route,
  },
  {
    path: "/ar/about",
    name: "ar-about",
    element: <ArAbout />,
    route: Route,
  },
  {
    path: "/ar/contact",
    name: "ar-contact",
    element: <ArContact />,
    route: Route,
  },
  {
    path: "/ar/faq",
    name: "ar-faq",
    element: <ArFaq />,
    route: Route,
  },
  {
    path: "/ar/taxi-service-makkah",
    name: "ar-taxi-service-makkah",
    element: <ArTaxiServiceInMikkah />,
    route: Route,
  },
  {
    path: "/ar/taxi-service-madinah",
    name: "ar-taxi-service-madinah",
    element: <ArTaxiServiceInMadinah />,
    route: Route,
  },
  {
    path: "/ar/jaddah-airport-taxi-service",
    name: "ar-jaddah-airport-taxi-service",
    element: <ArJaddahAirportTaxiService />,
    route: Route,
  },
  {
    path: "/ar/hotel-transport",
    name: "ar-hotel-transport",
    element: <ArHotelTransport />,
    route: Route,
  },
  {
    path: "/ar/airport-transfers",
    name: "ar-airport-transfers",
    element: <ArAirportTransfers />,
    route: Route,
  },
  {
    path: "/ar/ziyarat-taxi-service",
    name: "ar-ziyarat-taxi-service",
    element: <ArZiyaratTaxiService />,
    route: Route,
  },
];

export const listingroutes=[

  {
    path: routes.listinggrid,
    name: "/packages",
    element: <ListingGrid />,
    route: Route,
  },
 {
  path: `${routes.listingdetails}/:id`,
  name: "package-details",
  element: <ListingDetails />,
  route: Route,
},
 {
  path: `${routes.legacyListingdetails}/:id`,
  name: "legacy-package-details",
  element: <ListingDetails />,
  route: Route,
}


]

export const pageroutes=[

  // {
  //   path: routes.aboutus,
  //   name: "aboutus",
  //   element: <AboutUs />,
  //   route: Route,
  // },
  {
    path: routes.pricing,
    name: "pricing",
    element: <Pricing />,
    route: Route,
  },
  {
    path: routes.bookingcheckout,
    name: "booking-payment",
    element: <BookingCheckout />,
    route: Route,
  },
  {
    path: routes.booking,
    name: "booking",
    element: <Booking />,
    route: Route,
  },
  {
    path: routes.invoice,
    name: "invoice-details",
    element: <Invoice />,
    route: Route,
  },
  {
    path: routes.ourteam,
    name: "our-team",
    element: <OurTeam />,
    route: Route,
  },
  {
    path: routes.testimonial,
    name: "testimonial",
    element: <Testimonials />,
    route: Route,
  },
  {
    path: routes.termsconditions,
    name: "terms-condition",
    element: <TermsCondition />,
    route: Route,
  },
  {
    path: routes.legacyPrivacypolicy,
    name: "legacy-privacy-policy",
    element: <Navigate to={routes.privacypolicy} replace />,
    route: Route,
  },
  
  

]

export const blogroutes=[
  {
    path: "blog-list",
    name: "bloglist",
    element: <Navigate to={routes.bloglist} replace />,
    route: Route,
  },
  {
    path: "blog-grid",
    name: "bloggrid",
    element: <Navigate to={routes.bloglist} replace />,
    route: Route,
  },
  {
    path: "blog-details",
    name: "blogdetails",
    element: <Navigate to={routes.bloglist} replace />,
    route: Route,
  },

]

export const authenticationRoute = [
  {
    path: routes.forgotpassword,
    name: "login",
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.resetpassword,
    name: "login",
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.error404,
    name: "error-404",
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    name: "error-500",
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.maintenance,
    name: "maintenance",
    element: <Maintenance />,
    route: Route,
  },
  {
    path: routes.comingsoon,
    name: "coming-soon",
    element: <Comingsoon />,
    route: Route,
  },
];

export const usermodule = [
  {
    path: routes.dashboard,
    name: "user-dashboard",
    element: <UserDashboard />,
    route: Route,
  },
  {
    path: routes.settings,
    name: "settings",
    element: <UserSettings />,
    route: Route,
  },
  {
    path: routes.userintegration,
    name: "user-integration",
    element: <UserIntegration />,
    route: Route,
  },
  {
    path: routes.security,
    name: "security",
    element: <UserSecurity />,
    route: Route,
  },
  {
    path: routes.preference,
    name: "preference",
    element: <UserPreferences />,
    route: Route,
  },
  {
    path: routes.notification,
    name: "notification",
    element: <UserNotification />,
    route: Route,
  },

  // {
  //   path: routes.wallet,
  //   name: "wallet",
  //   element: <UserWallet />,
  //   route: Route,
  // },
  {
    path: routes.wishlist,
    name: "wishlist",
    element: <UserWishList />,
    route: Route,
  },
  {
    path: routes.messages,
    name: "messages",
    element: <UserMessages />,
    route: Route,
  },
  {
    path: routes.userDocuments,
    name: "user-documents",
    element: <UserDocuments />,
    route: Route,
  },
  {
    path: routes.userTransportDocuments,
    name: "transport-documents",
    element: <UserTransportDocuments />,
    route: Route,
  },
  {
    path: routes.payment,
    name: "payment",
    element: <UserPayment />,
    route: Route,
  },
  {
    path: routes.reviews,
    name: "reviews",
    element: <UserReview />,
    route: Route,
  },
  {
    path: routes.bookingcancelled,
    name: "bookingcancelled",
    element: <UserBookingCancelled />,
    route: Route,
  },
  {
    path: routes.bookingcancelled,
    name: "bookingcancelled",
    element: <UserBookingCancelled />,
    route: Route,
  },
  {
    path: routes.userBookings,
    name: "user-bookings",
    element: <UserBookings />,
    route: Route,
  },
  {
    path: routes.userBookingUpcoming,
    name: "user-booking-upcoming",
    element: <UserBookingUpcoming />,
  },
  {
    path: routes.userBookingComplete,
    name: "user-booking-complete",
    element: <UserBookingComplete />,
    route: Route,
  },
  {
    path: routes.userBookingCancelled,
    name: "user-booking-cancelled",
    element: <UserBookingCancelled />,
    route: Route,
  },
  {
    path: routes.userBookingInprogress,
    name: "user-booking-inprogress",
    element: <UserBookingInprogress />,
    route: Route,
  },
]
